<script>
import { defineComponent as _defineComponent } from "vue";
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { ref, inject, onMounted, onBeforeUnmount } from "vue";
import { useIntersectionObserver } from "@vueuse/core";
import { usePlayerAudioApi } from "../composables/private/usePlayerAudioApi";
import { usePlayerMediaApi } from "../composables/private/usePlayerMediaApi";
import { usePlayerRuntime } from "../composables/private/usePlayerRuntime";
import { MagicPlayerInstanceId, MagicPlayerOptionsKey } from "../symbols";
export default /* @__PURE__ */ _defineComponent({
  __name: "MagicPlayerAudio",
  setup(__props) {
    const injectedId = inject(MagicPlayerInstanceId, void 0);
    const injectedOptions = inject(MagicPlayerOptionsKey, void 0);
    if (!injectedId) {
      throw new Error("MagicPlayerVideo must be used within a MagicPlayerProvider");
    }
    if (!injectedOptions) {
      throw new Error("MagicPlayerVideo must be used within a MagicPlayerProvider");
    }
    const elRef = ref(void 0);
    const pausedByIntersection = ref(false);
    const { initialize, destroy } = usePlayerRuntime({
      id: injectedId,
      mediaRef: elRef,
      src: injectedOptions.src,
      srcType: injectedOptions.srcType
    });
    const { playing } = usePlayerMediaApi({
      id: injectedId,
      mediaRef: elRef
    });
    const { play, pause } = usePlayerAudioApi({
      id: injectedId
    });
    useIntersectionObserver(
      elRef,
      ([{ isIntersecting }]) => {
        if (!isIntersecting && playing.value) {
          pause();
          pausedByIntersection.value = true;
        } else if (isIntersecting && !playing.value && pausedByIntersection.value) {
          pausedByIntersection.value = false;
          play();
        }
      },
      {
        immediate: true
      }
    );
    onMounted(() => {
      initialize();
    });
    onBeforeUnmount(() => {
      destroy();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(
        "audio",
        {
          ref_key: "elRef",
          ref: elRef,
          class: "magic-player-audio"
        },
        null,
        512
        /* NEED_PATCH */
      );
    };
  }
});
</script>

<style>
.magic-player-audio {
  width: 100%;
}
</style>
